import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                                <section>
                                    <div className="">
                                        <div className="ilead-rgt people">
                                            <div className="innerpadding">
                                                <div className="ilead-contentarea">
                                                    <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                        <span className="heading">EMPATHY – WHAT IS IT AND HOW CAN I BUILD IT?</span>
                                                    </div>
                                                    <p>This is the most important requirement of all to building trust
                                                        at any of the levels described so far and involves both
                                                        ‘perspective taking’ and ‘empathic concern’:<a
                                                            className="superscripttext"
                                                            href="further_info.php?course=300"><sup>4</sup></a></p>
                                                    <div className="lightgreencontentbg keyquestionpad">
                                                        <ul className="greenbullet-list">

                                                            <li><span
                                                                className="subtiltereg">‘Perspective taking’</span> involves
                                                                taking the time to listen to someone else’s opinion
                                                                before making a decision, anticipating their feelings or
                                                                reactions and considering matters from their point of
                                                                view, or ‘perspective’
                                                            </li>
                                                            <li><span
                                                                className="subtiltereg">‘Empathic concern’</span> is the
                                                                ability to vicariously experience another’s reactions
                                                                and feelings – or ‘putting yourself in their shoes.’
                                                            </li>

                                                        </ul>
                                                    </div>
                                                    <p>Empathy is more than effective listening. It involves setting
                                                        aside your own feelings and opinions and showing someone else
                                                        that you understand what they are communicating – as if from
                                                        within their own experience of it, yet remaining separate. In
                                                        other words, it’s about understanding the person in addition to
                                                        what he or she is telling you.</p>
                                                    <div className="border_subtitle">Practical steps to achieve
                                                        empathy<a className="superscripttext"
                                                                  href="further_info.php?course=300"><sup>5</sup></a>
                                                    </div>
                                                    <p><span
                                                        className="subtiltereg">Reflection of feelings and content</span>
                                                    </p>
                                                    <p>To empathise with another, you need to watch and listen for both
                                                        verbal and non-verbal messages. This means checking that you
                                                        understand the underlying and often implicit emotions which
                                                        accompany statements, by verbalising them for the speaker to
                                                        confirm or otherwise (‘reflection of feeling’). For example, if
                                                        you think they sound anxious, ask whether this is how they are
                                                        feeling.</p>
                                                    <p>‘Reflection of content’ means repeating statements made to
                                                        demonstrate your attention and verify mutual understanding.</p>
                                                    <div className="paraspace"><p>Other ways to build empathy could
                                                        include:</p></div>
                                                    <ul className="greenbullet-list">

                                                        <li>Sharing similar experiences of your own</li>
                                                        <li>‘Mirroring’ or copying the other person’s behaviour, but in
                                                            subtle ways, such as sitting if they are seated, or
                                                            adjusting the speed and tone of your voice
                                                        </li>
                                                        <li>Showing them that you are trying to see things from their
                                                            perspective
                                                        </li>
                                                        <li>Noticing how the other person is feeling as well as what
                                                            they are saying
                                                        </li>
                                                        <li>Paraphrasing or summarising what they have told you when
                                                            they have finished, to check your understanding
                                                        </li>
                                                        <li>Asking for (and showing that you welcome) feedback.</li>
                                                    </ul>
                                                    <div className="ilead-contentarea">
                                                        <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                            <span className="heading">ADDITIONAL TIPS FOR BUILDING EMPATHY</span>
                                                        </div>
                                                        <div className="border_subtitle">Speak up and provide your
                                                            views
                                                        </div>
                                                        <p>Appearing to not contribute to conversations can lead to
                                                            misunderstanding and mistrust. So, talk easily and openly –
                                                            without dominating things. However, if you have an ‘issue’
                                                            to resolve with someone, try not to talk about them behind
                                                            their backs. It’s much better to confront matters
                                                            dispassionately, in an open and honest way which often
                                                            creates more positive relationships. In addition, you will,
                                                            at least, build a reputation for being straightforward
                                                            rather than as a gossip or trouble-maker. The alternative is
                                                            to let frustrations fester which can cause irreparable
                                                            damage.</p>

                                                        <div className="left-btn"><div  onClick={this.props.handleChangePage('Page4')}
                                                                                     className="button-next-previous-done">&lt;&lt; Previous </div>
                                                        </div>
                                                        <div className="right-btn"><div  onClick={this.props.handleChangePage('Page6')}
                                                                                      className="button-next-previous-done">Next &gt;&gt;</div>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}